module.exports = __webpack_public_path__ + "static/media/proposal_verification_audio.bc6a33ea.mp3";